import { FormSteps } from '@authentic/loyalty-pwa/components/Form';
import { Typography, link } from '@authentic/loyalty-pwa/util';
import { backgroundColors, breakpoints, colors } from '@authentic/loyalty-pwa/util/variables';
import { ComponentChildren, FunctionalComponent, h } from 'preact';
import styled from 'styled-components';
import { DelTacoNav } from './del-taco-nav/DelTacoNav';
import { Button } from '@authentic/loyalty-pwa/components';
import { BackIcon } from '../icons/Back';

interface SignUpInterface {
  pageTitle?: string; // this is the title (string) used to set on the <title>Title Page</title> into html code
  title?: string | h.JSX.Element; // this is the title (string) or component (Element) used to display on the layout
  subtitle?: string;
  stepTitle?: string;
  headline?: string;
  children?: ComponentChildren;
  activeStep?: number;
  topHint?: string;
  icon?: h.JSX.Element;
  className?: any;
  stepCallbackOnClick?: (step: number) => void;
}

const SignUpStyled = styled.div`
  background: ${backgroundColors.white};
  padding: 32px 30px;

  @media screen and (min-width: ${breakpoints.sm}) {
    background: ${backgroundColors.lightGray};
  }
`;

const Headline = styled.div`
  margin-bottom: 16px;
  text-align: center;
  text-transform: uppercase;
`;

const Subtitle = styled.div`
  margin-bottom: 32px;
  text-align: center;
`;

const BackIconStyle = styled.span`
  position: absolute;
  left: 18px;
`

const BackButton = styled.div`
  background: ${backgroundColors.white};
  margin: 0 auto;
  max-width: 550px;
  position: relative;
  button{
    background: #E7E7E7;
    color: black;
    border: 0;
    text-transform: uppercase;
    cursor: pointer;
  }
  @media screen and (max-width: ${breakpoints.sm}) {
    position: absolute;
    top: 60px;
    left: 0;
    width: 100%;
    max-width: 100%;
    button{
      background: #F7F7F7;
      color: black;
      text-transform: uppercase;
    }
  }
`

const FormSeparator = styled.div`
  border: 1px solid ${colors.gray1};
  &.first {
    margin-bottom: 35px;

    @media screen and (min-width: ${breakpoints.sm}) {
      display: none;
    }
  }
  &.second {
    margin-top: 20px;
    margin-bottom: 37px;
  }
`;

const FormHint = styled.div`
  font-size: 12px;
  line-height: 16px;
  margin-bottom: 11px;
  text-align: right;
`;

const FormTitle = styled.div`
  text-align: center;
  margin: 0 0 16px;
`;

const FormStepsWrapper = styled.div`
  margin-bottom: 12px;
`;

const StepTitleStyle = styled.div`
  margin-top: 10px;
  text-transform: uppercase;
`

const WhiteBox = styled.div`
  padding: 0 0 30px;
  text-align: center;

  @media screen and (min-width: ${breakpoints.sm}) {
    background: ${backgroundColors.white};
    margin: 0 auto;
    max-width: 550px;
    padding: 40px 50px;
  }
`;

export const SignUpContainer: FunctionalComponent<SignUpInterface> = ({
  pageTitle = '',
  title,
  subtitle,
  headline,
  children,
  activeStep,
  topHint = '*Required Field',
  icon,
  stepTitle,
  className,
  stepCallbackOnClick
}) => {
  return (
    <DelTacoNav title={(typeof (title) === 'string') ? title : pageTitle}>
      <SignUpStyled className={className}>
        <Headline>
          {title && <Typography variant="headline1">{title}</Typography>}
        </Headline>
        <Subtitle>
          {subtitle && (
            <Typography variant="body2">
              {subtitle}
              <b>
                <a href={link('/sign-in')}> Sign In</a>
              </b>
            </Typography>
          )}
        </Subtitle>
        {stepTitle &&
        (<BackButton>
          <Button fullWidth onClick={() => stepCallbackOnClick?.(1)}>
            <BackIconStyle><BackIcon/></BackIconStyle>SIGN UP
          </Button>
        </BackButton>)
        }
        <WhiteBox className="white-box">
          {headline && (
            <FormTitle>
              <Typography variant="body1" weight="bold">
                {headline}
              </Typography>
            </FormTitle>
          )}
          {activeStep && (
            <FormStepsWrapper>
              <FormSteps steps={2} activeStep={activeStep}>
                {icon && icon}
              </FormSteps>
              <StepTitleStyle style={{marginTop: "10px"}}>
                {stepTitle && <Typography variant="headline1">{stepTitle}</Typography>}
              </StepTitleStyle>

            </FormStepsWrapper>
          )}
          {topHint && <FormHint>{topHint}</FormHint>}
          {children}
        </WhiteBox>
      </SignUpStyled>
    </DelTacoNav>
  );
};
